import { z } from 'zod'

import { Profile } from './profile'

import { Pagination } from '@/types/app/request'
import { Manager, ManagerBinding } from '@/types/park/manager'

/** Choices available to filter the Konsole users in the list page. */
export const AdminKonsoleUserPage = z.enum(['ALL', 'true', 'false'])
export type AdminKonsoleUserPage = z.infer<typeof AdminKonsoleUserPage>

const SettingsUser = z.object({
    avatar: z.string().url().nullable(),
    client: ManagerBinding.extend({
        has_order: z.boolean(),
    }).array(),
})

export type SettingsUser = z.infer<typeof SettingsUser>

/** User that use the Konsole. */
export const KonsoleUser = z.object({
    id: z.number().positive(),
    email: z.string().email(),
    username: z.string().min(1),
    first_name: z.string().min(1),
    last_name: z.string().min(1).toUpperCase(),
    is_superuser: z.boolean(),
    is_staff: z.boolean(),
    groups: Profile.array(),
    profil: SettingsUser,
})

export type KonsoleUser = z.infer<typeof KonsoleUser>

/** Payload of a Konsole user. */
export const KonsoleUserPayload = KonsoleUser.omit({
    id: true,
    profil: true,
}).extend({
    groups: Profile.shape.id.array(),
    profil: z
        .object({
            client: Manager.shape.id.array(),
        })
        .nullable(),
})

export type KonsoleUserPayload = z.infer<typeof KonsoleUserPayload>

// TODO: Remove when the password is set in the activation page
/** Form to create a Konsole user. */
export const KonsoleUserCreatePayload = KonsoleUserPayload.extend({
    password: z.string().min(12),
})

export type KonsoleUserCreatePayload = z.infer<typeof KonsoleUserCreatePayload>

/** Konsole user list paginated. */
export const KonsoleUsersRequest = Pagination.extend({
    results: KonsoleUser.array(),
})

export type KonsoleUsersRequest = z.infer<typeof KonsoleUsersRequest>
